import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {CampaignService} from '../campaign/service/campaign.service';
import {environment} from '../../../environments/environment';
import { FirebaseService } from 'src/app/ecare-parent/services/firebase.service';
import { listChanges } from '@angular/fire/database';
import { DashboardService } from 'src/app/ecare-parent/dashboard/services/dashboard.service';
import { PatientService } from 'src/app/ecare-parent/patient/service/patient.service';
declare var DDP_ENV: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  allPatientIdList = [];
  patientListLoaded = false;
  metricArray = [];
  tempThreshold: any;
  spo2Threshold: any;
  heartRateThreshold: any;
  bloodPressureThreshold: any;
  bloodGlucoseThreshold: any;
  thresholdCounter = 0;

  constructor(private router: Router,
              private campaignService: CampaignService,
              private firebaseService: FirebaseService,
              private dashboardService: DashboardService) {
    
  }

  ngOnInit() {
    this.getThresholds();
    this.firebaseService.getAllPinnedPatients().subscribe(pinnedPatientList => {
      const listObject = pinnedPatientList;
      listObject.docs.forEach(element => {
        let patientList = element.data();
        patientList['patientList'].forEach(pId => {
          if (this.allPatientIdList.indexOf(pId) === -1) {
              this.allPatientIdList.push(pId);
          }
        });
      });
      this.patientListLoaded = true;
      setTimeout(() => {
        this.getMetrics();
      }, 10000);
      
    });
    
  }

  getMetrics() { 
    console.log('----------------------') 
    console.log(this.tempThreshold)
    this.allPatientIdList.forEach(pId => {
      let patientMetricMap = new Map();
      this.dashboardService.getPatientById(pId).subscribe(patient => {
        if (patient !== null && patient !== undefined) {
          try {
            const patientDetails = patient.json();
            patientMetricMap['patientName'] =  patientDetails['firstName'] + ' ' + patientDetails['lastName'] + '(' + patientDetails['mrn'] + ')'

            patientMetricMap['patientMobile'] =  patientDetails['mobileNumber']

            this.dashboardService.getMetricByPatientIdAndMetricId(pId, 'TEMPERATURE').subscribe(data => {
              const tempArray = data['TEMPERATURE'];
              if (tempArray.length > 0) {
                let color = '';
                if (tempArray[0].doubleValues[0] > this.tempThreshold['upperThreshold'][0] || tempArray[0].doubleValues[0] < this.tempThreshold['lowerThreshold'][0]) {
                  color = 'red';
                }
                patientMetricMap['TEMPERATURE'] = tempArray[0].doubleValues[0] + '@' + tempArray[0].timestamp + '@' + color
              } else {
                patientMetricMap['TEMPERATURE'] = 'NA';
              }
            });

            this.dashboardService.getMetricByPatientIdAndMetricId(pId, 'SPO2_OXYGEN').subscribe(data => {
              const tempArray = data['SPO2_OXYGEN'];
              if (tempArray.length > 0) {
                let color = '';
                if ((this.spo2Threshold['upperThreshold'][0] !== 0 && this.spo2Threshold['lowerThreshold'][0] !== 0) && ( tempArray[0].doubleValues[0] > this.spo2Threshold['upperThreshold'][0] || tempArray[0].doubleValues[0] < this.spo2Threshold['lowerThreshold'][0])) {
                  color = 'red';
                }
                patientMetricMap['SPO2_OXYGEN'] = tempArray[0].doubleValues[0] + '@' + tempArray[0].timestamp + '@' + color
              } else {
                patientMetricMap['SPO2_OXYGEN'] = 'NA';
              }
            })

            this.dashboardService.getMetricByPatientIdAndMetricId(pId, 'Heart_Rate').subscribe(data => {
              const tempArray = data['Heart_Rate'];
              if (tempArray.length > 0) {
                let color = '';
                if ((this.heartRateThreshold['upperThreshold'][0] !== 0 && this.heartRateThreshold['lowerThreshold'][0] !== 0) && ( tempArray[0].doubleValues[0] > this.heartRateThreshold['upperThreshold'][0] || tempArray[0].doubleValues[0] < this.heartRateThreshold['lowerThreshold'][0])) {
                  color = 'red';
                }
                patientMetricMap['Heart_Rate'] = tempArray[0].doubleValues[0] + '@' + tempArray[0].timestamp + '@' + color
              } else {
                patientMetricMap['Heart_Rate'] = 'NA';
              }
            });

            this.dashboardService.getMetricByPatientIdAndMetricId(pId, 'BLOOD_PRESSURE').subscribe(data => {
              const tempArray = data['BLOOD_PRESSURE'];
              if (tempArray.length > 0) {
                let color = '';
                if (
                  tempArray[0].doubleValues[0] > this.bloodPressureThreshold['upperThreshold'][0] || tempArray[0].doubleValues[1] > this.bloodPressureThreshold['upperThreshold'][1] ||
                  tempArray[0].doubleValues[0] < this.bloodPressureThreshold['lowerThreshold'][0] || tempArray[0].doubleValues[1] < this.bloodPressureThreshold['lowerThreshold'][1]
                ) {
                  color = 'red';
                }
                patientMetricMap['BLOOD_PRESSURE'] = tempArray[0].doubleValues[0] + '/' + tempArray[0].doubleValues[1] + '@' + tempArray[0].timestamp + '@' + color
              } else {
                patientMetricMap['BLOOD_PRESSURE'] = 'NA';
              }
            });

            this.dashboardService.getMetricByPatientIdAndMetricId(pId, 'BLOOD_GLUCOSE').subscribe(data => {
              const tempArray = data['BLOOD_GLUCOSE'];
              if (tempArray.length > 0) {
                let color = '';
                if ((this.bloodGlucoseThreshold['upperThreshold'][0] !== 0 && this.bloodGlucoseThreshold['lowerThreshold'][0] !== 0) && ( tempArray[0].doubleValues[0] > this.bloodGlucoseThreshold['upperThreshold'][0] || tempArray[0].doubleValues[0] < this.bloodGlucoseThreshold['lowerThreshold'][0])) {
                  color = 'red';
                }
                patientMetricMap['BLOOD_GLUCOSE'] = tempArray[0].doubleValues[0] + '@' + tempArray[0].timestamp
              } else {
                patientMetricMap['BLOOD_GLUCOSE'] = 'NA';
              }
            });

            this.metricArray.push(patientMetricMap)
            console.log(this.metricArray)
          } catch (error) { 
            // swallow
          }
        }
      })
    });
  }

  getThresholds() {
// TEMPERATURE
// SPO2_OXIGEN
// Heart_Rate
// BLOOD_PRESSURE
// BLOOD_GLUCOSE
    this.dashboardService.getMetricByName('TEMPERATURE').subscribe(tempThreshold => {
        this.tempThreshold = tempThreshold;
        this.thresholdCounter += 1;
    });
    this.dashboardService.getMetricByName('SPO2_OXYGEN').subscribe(spo2Threshold => {
      this.spo2Threshold = spo2Threshold;
      this.thresholdCounter += 1;
    });
    this.dashboardService.getMetricByName('Heart_Rate').subscribe(heartRate => {
      this.heartRateThreshold = heartRate;
      this.thresholdCounter += 1;
    });
    this.dashboardService.getMetricByName('BLOOD_PRESSURE').subscribe(bloodPressure => {
      this.bloodPressureThreshold = bloodPressure;
      this.thresholdCounter += 1;
    });
    this.dashboardService.getMetricByName('BLOOD_GLUCOSE').subscribe(bloodGlucose => {
      this.bloodGlucoseThreshold = bloodGlucose;
      this.thresholdCounter += 1;
    });
  }

}
